import axios from 'axios'
import { config } from '../../../config'
import { applyInterceptors } from '../interceptors'

const baseURL = config.ACCOUNT_SERVICE_URL
const service = axios.create({ baseURL })

applyInterceptors(service)

export { baseURL as baseUrl, service }
